import { useEffect, useState } from "react";
import { History } from "lucide-react";
import { api } from "../lib/api";
import { getRecent, clearRecent } from "../lib/recent";
import ProductCard from "./ProductCard";
import { useAuth } from "../context/AuthContext";

export default function RecentlyViewed() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  useEffect(() => {
    const ids = user ? getRecent() : [];
    if (ids.length) api.get("/products", { params: { ids: ids.join(",") } }).then((r) => setItems(r.data)); else setItems([]);
  }, [user]);
  if (!user || !items.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 pt-4 pb-12" data-testid="recently-viewed">
      <div className="flex items-end gap-4 mb-6">
        <div>
          <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight flex items-center gap-2"><History className="text-[#00f0ff]" />Recently viewed</h2>
          <p className="text-sm text-slate-500">Pick up where you left off</p>
        </div>
        <button data-testid="recently-viewed-clear" onClick={() => { clearRecent(); setItems([]); }} className="ml-auto text-sm text-slate-400 hover:text-[#ff5500] transition-colors">Clear history</button>
      </div>
      <div className="flex gap-5 overflow-x-auto no-scrollbar pb-2">
        {items.map((p, i) => <div key={p.id} className="w-56 shrink-0" data-testid={`recent-item-${p.id}`}><ProductCard p={p} i={i} /></div>)}
      </div>
    </section>
  );
}
